import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IOrganization } from './organizations-claim';

export interface IOrganizationsState {
    organizations: IOrganization[];
}

const initialState: IOrganizationsState = {
    organizations: [],
};

const organizationsSlice = createSlice({
    name: 'organizations',
    initialState,
    reducers: {
        setOrganizations: (
            state,
            { payload }: PayloadAction<IOrganization[]>
        ) => {
            state.organizations = payload;
        },
    },
});

export const { setOrganizations } = organizationsSlice.actions;
export default organizationsSlice.reducer;
